import {
  Address,
  camelToKebab,
  ChainKey,
  getChainSlug,
  ProtocolKey,
} from "@silo/types";

export function getSanctionedAddressesKey(): string {
  return "sanctioned-addresses";
}

export function getTokenCmcMetaKey(
  chainKey: ChainKey,
  tokenAddress: Address
): string {
  return `chain:${getChainSlug(chainKey)}:token-cmc-meta:${tokenAddress}`;
}

export function getTokenPriceKey(
  chainKey: ChainKey,
  tokenAddress: Address
): string {
  return `chain:${getChainSlug(chainKey)}:token-price-usd:${tokenAddress}`;
}

export function getMarketMetaKey(
  protocolKey: ProtocolKey,
  marketAddress: Address
): string {
  const protocolSlug = camelToKebab(protocolKey);

  return `protocol:${protocolSlug}:market-meta:${marketAddress}`;
}

export function getMarketProtocolKeyMapKey(): string {
  return `market-protocol-key-map`;
}

export function getShareTokenMetaMapKey(): string {
  return `share-token-meta-map`;
}

export function getMerklCampaignMetaKey(): string {
  return "merkl-campaign-meta";
}

export function getMerklHistoricalRewardTokensKey(): string {
  return "merkl-historical-reward-tokens";
}

export function getUserMerklRewardsInfoKey(
  protocolKey: ProtocolKey,
  user: Address
): string {
  const protocolSlug = camelToKebab(protocolKey);

  return `protocol:${protocolSlug}:user-merkl-rewards-info:${user}`;
}
